import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { GRID_DATA_QUERY_PREFIX } from './utils/constants'

// Invalidate in one call Grid Data related queries
// GetUsersPaged, GetInvitableUsers
export const useGridDataQueryInvalidate = () => {
  const queryClient = useQueryClient()
  return useCallback(() => {
    return queryClient.invalidateQueries({ queryKey: [GRID_DATA_QUERY_PREFIX] })
  }, [queryClient])
}
